
import React from 'react';
import { useNavigate,Link } from 'react-router-dom';
import "./HomePageContent.css";
import { FaCode, FaMobileAlt, FaBullhorn, FaCloud, FaTools } from "react-icons/fa";
import { SiSalesforce } from 'react-icons/si';
import { FaUserTie, FaFileAlt, FaHandshake, FaEnvelope } from "react-icons/fa";
import WhoWeAre from "./WhoWeAre";
const HomePage = () => {

    const navigate = useNavigate();




    return (
        <div className="home-wrapper">
            <section className="hero">
                <h1 className="hero-heading">Welcome to A.P Tech Solution</h1>
                <p className="hero-subheading">Transforming Ideas Into Digital Reality</p>
                <p className="hero-tagline">Your Trusted Partner for Software, Web & Mobile Solutions.</p>
                <Link to="/contact" state={{ scrollTo: "form" }}>
                     <button className="cta-button">Get in Touch</button>
                </Link>
               
               
            </section>


            < WhoWeAre />


            <section className="services why-choose">
                <h2 className=" section-heading ">Our Core Services</h2>
                <div className="services-grid">
                    <div className="service-card" onClick={() => navigate('/WebsiteDevelopment')}>
                        <FaCode className="service-icon" />
                        <h3>Website Development</h3>
                        <p>Modern, scalable, and responsive websites tailored to your business goals.</p>
                    </div>

                    <div className="service-card" onClick={() => navigate('/MobileAppDevelopment')}>
                        <FaMobileAlt className="service-icon" />
                        <h3>Mobile App Development</h3>
                        <p>Android, iOS, and hybrid apps to boost your digital presence.</p>
                    </div>

                    <div className="service-card" onClick={() => navigate('/SalesForceDevelopment')}>
                        <SiSalesforce className="service-icon" />
                        <h3>SalesForce Development</h3>
                        <p>UI/UX, branding, and creative graphics to elevate your business identity.</p>
                    </div>

                    <div className="service-card" onClick={() => navigate('/DigitalMarketing')}>
                        <FaBullhorn className="service-icon" />
                        <h3>Digital Marketing</h3>
                        <p>SEO, Social Media, Ads & Content strategies to grow your visibility.</p>
                    </div>

                    <div className="service-card" onClick={() => navigate('/SoftwareSolutions')}>
                        <FaCloud className="service-icon" />
                        <h3>Software Solutions</h3>
                        <p>CRM, ERP, and Cloud-based custom software for business needs.</p>
                    </div>

                    <div className="service-card" onClick={() => navigate('/MaintenanceAndSupport')}>
                        <FaTools className="service-icon" />
                        <h3>Maintenance & Support</h3>
                        <p>Ongoing updates, security, and performance monitoring services.</p>
                    </div>
                </div>
            </section>

            <section className="why-choose">
                <h2 className="section-heading">Why Choose A.P Tech Solution?</h2>
                <div className="why-grid">
                    <div className="why-card">
                        <h3>Expertise That Delivers</h3>
                        <p>Our experienced team builds high-performing software, websites, and mobile apps that work flawlessly.</p>
                    </div>
                    <div className="why-card">
                        <h3>Client-Centric Approach</h3>
                        <p>We deeply understand your needs and deliver tailor-made solutions that align with your goals.</p>
                    </div>
                    <div className="why-card">
                        <h3>Innovative & Scalable</h3>
                        <p>We develop future-ready systems using scalable and secure technologies that grow with your business.</p>
                    </div>
                    <div className="why-card">
                        <h3>Transparent Process</h3>
                        <p>We maintain clear, consistent communication throughout the project lifecycle — no surprises, ever.</p>
                    </div>
                    <div className="why-card">
                        <h3>End-to-End Support</h3>
                        <p>From planning to post-launch maintenance, we’re always available to ensure smooth operations.</p>
                    </div>
                    <div className="why-card">
                        <h3>Cost-Effective Solutions</h3>
                        <p>Get the best return on your investment with quality service at competitive pricing.</p>
                    </div>
                    <div className="why-card">
                        <h3>Agile Methodology</h3>
                        <p>We follow agile practices to ensure rapid delivery and flexibility in changing requirements.</p>
                    </div>
                    <div className="why-card">
                        <h3>Trusted by Clients</h3>
                        <p>Our long-term partnerships and testimonials speak volumes about our reliability and results.</p>
                    </div>
                    <div className="why-card">
                        <h3>Proven Track Record</h3>
                        <p>With numerous successful projects across industries, we bring reliability, consistency, and results to every engagement.</p>
                    </div>

                </div>
            </section>
            
            <div className="how-we-work-wrapper">
                <h2>HOW WE WORK</h2>
                <p>
                    Initial meetings with sales department to discuss your needs and analyze how we may best serve
                    them. Including, an outsourced and managed services requirement analysis.
                </p>

                <div className="how-we-work-grid">
                    <div className="how-we-work-card orange">
                        <div className="icon-wrapper">
                            <FaUserTie />
                        </div>
                        <h4>UNDERSTAND OUR CLIENTS</h4>
                        <ul>
                            <li>Call or Meeting</li>
                            <li>NDA (Non-Disclosure)</li>
                        </ul>
                        <span className="dot"></span>
                    </div>

                    <div className="how-we-work-card cyan">
                        <div className="icon-wrapper">
                            <FaFileAlt />
                        </div>
                        <h4>PROJECT ESTIMATION</h4>
                        <ul>
                            <li>Gather Requirements</li>
                            <li>Perfect Proposal</li>
                        </ul>
                        <span className="dot"></span>
                    </div>

                    <div className="how-we-work-card green">
                        <div className="icon-wrapper">
                            <FaHandshake />
                        </div>
                        <h4>STRATEGIC PARTNERSHIP</h4>
                        <ul>
                            <li>T&amp;C Communicated</li>
                            <li>Project Agreement</li>
                        </ul>
                        <span className="dot"></span>
                    </div>

                    <div className="how-we-work-card blue">
                        <div className="icon-wrapper">
                            <FaEnvelope />
                        </div>
                        <h4>WORKING TOGETHER</h4>
                        <Link to="/contact" state={{ scrollTo: "form" }}>
                            <button className="start-btn">LET’S START WITH US ➤</button>
                        </Link>
                       
                        <span className="dot"></span>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default HomePage;
